import { PARENT_TYPE } from '@atlassian/jira-platform-field-config';
import type { DataTransformFn } from '../../../bulk-edit-transform/types';
import type { jiraBusinessParentFieldFragment as ParentField } from '../fragment';
import type { ParentFormData } from './types';

export const transformParentFieldForOptimisticUpdates: DataTransformFn<
	ParentField,
	ParentFormData
> = (existingField: ParentField, fieldData: ParentFormData): ParentField => ({
	...existingField,
	parentIssue: {
		__typename: 'JiraIssue',
		id: fieldData.id?.toString() || '',
		issueId: fieldData.value.toString(),
		key: fieldData.key,
		rankField: [],
		fields: [
			{
				fieldId: 'summary',
				aliasFieldId: null,
				name: 'Summary',
				type: 'summary',
				text: fieldData.fields.summary,
				__typename: 'JiraSingleLineTextField',
			},
			{
				fieldId: 'issuetype',
				aliasFieldId: null,
				name: 'Issue Type',
				type: 'issuetype',
				__typename: 'JiraIssueTypeField',
				issueType: {
					__typename: 'JiraIssueType',
					name: fieldData?.fields?.issuetype?.name || '',
					avatar: {
						medium: fieldData?.fields?.issuetype?.iconUrl?.replace('xsmall', 'medium'),
						__typename: 'JiraAvatar',
					},
				},
			},
		],
	},
});

export const parentOptimisticUpdatesHandler: {
	[key: string]: DataTransformFn<ParentField, ParentFormData>;
} = {
	[PARENT_TYPE]: transformParentFieldForOptimisticUpdates,
};
